<template>
	<footer class="container-footer">
		<div class="container-xl">
			<div class="row">
				<div class="col-md-4 d-flex align-items-center justify-content-center justify-content-md-start footer-logo" v-if="footerData.logo">
					<img  :src="`${footerData.logo}`" alt="" :style="{ 'max-height': footerData.logoMaxHeight, 'max-width': footerData.logoMaxWidth }">
				</div>

	
				<div class="col footer-address">
					<div class="row">
						<div v-if="footerData.footnote.firma && footerData.footnote.firma.value && !footerData.footnote['name_der_geschäftsstelle']" class="col-12 col-sm-6 col-lg-6">
							<div class="row">
								<div class="col-sm-12 col-md-5 col-lg-4 contact-field">
									<span>{{ footerData.footnote.firma.label }}</span>
								</div>

								<div class="col-sm-12 col-md-7 col-lg contact-value">
									<span>{{ footerData.footnote.firma.value }}</span>
								</div>
							</div>
						</div>

						<div v-if="footerData.footnote['name_der_geschäftsstelle'] && footerData.footnote['name_der_geschäftsstelle'].value" class="col-12 col-sm-6 col-lg-6">
							<div class="row">
								<div class="col-sm-12 col-md-5 col-lg-4 contact-field">
									<span>{{ footerData.footnote['name_der_geschäftsstelle'].label }}</span>
								</div>

								<div class="col-sm-12 col-md-7 col-lg contact-value">
									<span>{{ footerData.footnote['name_der_geschäftsstelle'].value }}</span>
								</div>
							</div>
						</div>

						<div v-if="footerData.footnote.telefon && footerData.footnote.telefon.value" class="col-12 col-sm-6 col-lg-6">
							<div class="row">
								<div class="col-sm-12 col-md-5 col-lg-4 contact-field">
									<span>{{ footerData.footnote.telefon.label }}</span>
								</div>

								<div class="col-sm-12 col-md-7 col-lg contact-value">
									<span><a :href="`tel:${footerData.footnote.telefon.value}`">{{ footerData.footnote.telefon.value }}</a></span>
								</div>
							</div>
						</div>

						<div v-if="footerData.footnote.straße && footerData.footnote.straße.value" class="col-12 col-sm-6 col-lg-6">
							<div class="row">
								<div class="col-sm-12 col-md-5 col-lg-4 contact-field">
									<span>{{ footerData.footnote.straße.label }}</span>
								</div>

								<div class="col-sm-12 col-md-7 col-lg contact-value">
									<span>{{ footerData.footnote.straße.value }}&nbsp;</span>
									<span v-if="footerData.footnote.hausnr && footerData.footnote.hausnr.value">{{ footerData.footnote.hausnr.value }}</span>
								</div>
							</div>
						</div>

						<div v-if="footerData.footnote.fax && footerData.footnote.fax.value" class="col-12 col-sm-6 col-lg-6">
							<div class="row">
								<div class="col-sm-12 col-md-5 col-lg-4 contact-field">
									<span>{{ footerData.footnote.fax.label }}</span>
								</div>

								<div class="col-sm-12 col-md-7 col-lg contact-value">
									<span>{{ footerData.footnote.fax.value }}</span>
								</div>
							</div>
						</div>

						<div v-if="(footerData.footnote.plz || footerData.footnote.ort)" class="col-12 col-sm-6 col-lg-6">
							<div class="row">
								<div class="col-sm-12 col-md-5 col-lg-4 contact-field">
									<span v-if="footerData.footnote.plz && footerData.footnote.plz.value">{{ footerData.footnote.plz.label }}<span v-if="(footerData.footnote.plz || footerData.footnote.plz.value) && (footerData.footnote.ort && footerData.footnote.ort.value)">,&nbsp;</span></span>
									<span v-if="footerData.footnote.ort && footerData.footnote.ort.value">{{ footerData.footnote.ort.label }}</span>
								</div>

								<div class="col-sm-12 col-md-7 col-lg contact-value">
									<span v-if="footerData.footnote.plz && footerData.footnote.plz.value">{{ footerData.footnote.plz.value }}<span v-if="(footerData.footnote.plz || footerData.footnote.plz.value) && (footerData.footnote.ort && footerData.footnote.ort.value)">&nbsp;</span>
									</span>
									<span v-if="footerData.footnote.ort && footerData.footnote.ort.value">{{ footerData.footnote.ort.value }}</span>
								</div>
							</div>
						</div>

						<div v-if="footerData.footnote['e-mail'] && footerData.footnote['e-mail'].value" class="col-12 col-sm-6 col-lg-6">
							<div class="row">
								<div class="col-sm-12 col-md-5 col-lg-4 contact-field">
									<span>{{ footerData.footnote['e-mail'].label }}</span>
								</div>

								<div class="col-sm-12 col-md-7 col-lg contact-value">
									<span><a :href="`mailto:${footerData.footnote['e-mail'].value}`">{{ footerData.footnote['e-mail'].value }}</a></span>
								</div>
							</div>
						</div>

						<div v-if="footerData.footnote.homepage && footerData.footnote.homepage.value" class="col-12 col-sm-6 col-lg-6">
							<div class="row">
								<div class="col-sm-12 col-md-5 col-lg-4 contact-field">
									<span>{{ footerData.footnote.homepage.label }}</span>
								</div>

								<div class="col-sm-12 col-md-7 col-lg contact-value">
									<span><a :href="`${footerData.footnote.homepage.value}`" target="_blank">{{ footerData.footnote.homepage.value }}</a></span>
								</div>
							</div>
						</div>
					</div>

					<template v-for="(footer, index) in footerData.footnote" :key="index">
						<div class="row" v-if="index == 'socialNetworks' && footer.values !=''">							
							<div class="col-md-8 contact-value">
								<div class="social-icon" v-if="footer.values.facebook">
									<a :href="footer.values.facebook" target="blank"><svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="facebook-square" class="svg-inline--fa fa-facebook-square fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"></path></svg></a>
								</div>

								<div class="social-icon" v-if="footer.values.instagram">
									<a :href="footer.values.instagram" target="blank"><svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="instagram-square" class="svg-inline--fa fa-instagram-square fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M224,202.66A53.34,53.34,0,1,0,277.36,256,53.38,53.38,0,0,0,224,202.66Zm124.71-41a54,54,0,0,0-30.41-30.41c-21-8.29-71-6.43-94.3-6.43s-73.25-1.93-94.31,6.43a54,54,0,0,0-30.41,30.41c-8.28,21-6.43,71.05-6.43,94.33S91,329.26,99.32,350.33a54,54,0,0,0,30.41,30.41c21,8.29,71,6.43,94.31,6.43s73.24,1.93,94.3-6.43a54,54,0,0,0,30.41-30.41c8.35-21,6.43-71.05,6.43-94.33S357.1,182.74,348.75,161.67ZM224,338a82,82,0,1,1,82-82A81.9,81.9,0,0,1,224,338Zm85.38-148.3a19.14,19.14,0,1,1,19.13-19.14A19.1,19.1,0,0,1,309.42,189.74ZM400,32H48A48,48,0,0,0,0,80V432a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V80A48,48,0,0,0,400,32ZM382.88,322c-1.29,25.63-7.14,48.34-25.85,67s-41.4,24.63-67,25.85c-26.41,1.49-105.59,1.49-132,0-25.63-1.29-48.26-7.15-67-25.85s-24.63-41.42-25.85-67c-1.49-26.42-1.49-105.61,0-132,1.29-25.63,7.07-48.34,25.85-67s41.47-24.56,67-25.78c26.41-1.49,105.59-1.49,132,0,25.63,1.29,48.33,7.15,67,25.85s24.63,41.42,25.85,67.05C384.37,216.44,384.37,295.56,382.88,322Z"></path></svg></a>
								</div>

								<div class="social-icon" v-if="footer.values.twitter">
									<a :href="footer.values.twitter" target="blank"><svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="twitter-square" class="svg-inline--fa fa-twitter-square fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-48.9 158.8c.2 2.8.2 5.7.2 8.5 0 86.7-66 186.6-186.6 186.6-37.2 0-71.7-10.8-100.7-29.4 5.3.6 10.4.8 15.8.8 30.7 0 58.9-10.4 81.4-28-28.8-.6-53-19.5-61.3-45.5 10.1 1.5 19.2 1.5 29.6-1.2-30-6.1-52.5-32.5-52.5-64.4v-.8c8.7 4.9 18.9 7.9 29.6 8.3a65.447 65.447 0 0 1-29.2-54.6c0-12.2 3.2-23.4 8.9-33.1 32.3 39.8 80.8 65.8 135.2 68.6-9.3-44.5 24-80.6 64-80.6 18.9 0 35.9 7.9 47.9 20.7 14.8-2.8 29-8.3 41.6-15.8-4.9 15.2-15.2 28-28.8 36.1 13.2-1.4 26-5.1 37.8-10.2-8.9 13.1-20.1 24.7-32.9 34z"></path></svg></a>
								</div>

								<div class="social-icon" v-if="footer.values.youtube">
									<a :href="footer.values.youtube" target="blank"><svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="youtube-square" class="svg-inline--fa fa-youtube-square fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M186.8 202.1l95.2 54.1-95.2 54.1V202.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-42 176.3s0-59.6-7.6-88.2c-4.2-15.8-16.5-28.2-32.2-32.4C337.9 128 224 128 224 128s-113.9 0-142.2 7.7c-15.7 4.2-28 16.6-32.2 32.4-7.6 28.5-7.6 88.2-7.6 88.2s0 59.6 7.6 88.2c4.2 15.8 16.5 27.7 32.2 31.9C110.1 384 224 384 224 384s113.9 0 142.2-7.7c15.7-4.2 28-16.1 32.2-31.9 7.6-28.5 7.6-88.1 7.6-88.1z"></path></svg></a>
								</div>

								<div class="social-icon" v-if="footer.values.linkedin">
									<a :href="footer.values.linkedin" target="blank"><svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="invision" class="svg-inline--fa fa-invision fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M407.4 32H40.6C18.2 32 0 50.2 0 72.6v366.8C0 461.8 18.2 480 40.6 480h366.8c22.4 0 40.6-18.2 40.6-40.6V72.6c0-22.4-18.2-40.6-40.6-40.6zM176.1 145.6c.4 23.4-22.4 27.3-26.6 27.4-14.9 0-27.1-12-27.1-27 .1-35.2 53.1-35.5 53.7-.4zM332.8 377c-65.6 0-34.1-74-25-106.6 14.1-46.4-45.2-59-59.9.7l-25.8 103.3H177l8.1-32.5c-31.5 51.8-94.6 44.4-94.6-4.3.1-14.3.9-14 23-104.1H81.7l9.7-35.6h76.4c-33.6 133.7-32.6 126.9-32.9 138.2 0 20.9 40.9 13.5 57.4-23.2l19.8-79.4h-32.3l9.7-35.6h68.8l-8.9 40.5c40.5-75.5 127.9-47.8 101.8 38-14.2 51.1-14.6 50.7-14.9 58.8 0 15.5 17.5 22.6 31.8-16.9L386 325c-10.5 36.7-29.4 52-53.2 52z"></path></svg></a>
								</div>

								<div class="social-icon" v-if="footer.values.xing">
									<a :href="footer.values.xing" target="blank"><svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="xing-square" class="svg-inline--fa fa-xing-square fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM140.4 320.2H93.8c-5.5 0-8.7-5.3-6-10.3l49.3-86.7c.1 0 .1-.1 0-.2l-31.4-54c-3-5.6.2-10.1 6-10.1h46.6c5.2 0 9.5 2.9 12.9 8.7l31.9 55.3c-1.3 2.3-18 31.7-50.1 88.2-3.5 6.2-7.7 9.1-12.6 9.1zm219.7-214.1L257.3 286.8v.2l65.5 119c2.8 5.1.1 10.1-6 10.1h-46.6c-5.5 0-9.7-2.9-12.9-8.7l-66-120.3c2.3-4.1 36.8-64.9 103.4-182.3 3.3-5.8 7.4-8.7 12.5-8.7h46.9c5.7-.1 8.8 4.7 6 10z"></path></svg></a>
								</div>
								
								<div class="social-icon" v-if="footer.values.googleplus">
									<a :href="footer.values.googleplus" target="blank"><svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="google-plus-square" class="svg-inline--fa fa-google-plus-square fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM164 356c-55.3 0-100-44.7-100-100s44.7-100 100-100c27 0 49.5 9.8 67 26.2l-27.1 26.1c-7.4-7.1-20.3-15.4-39.8-15.4-34.1 0-61.9 28.2-61.9 63.2 0 34.9 27.8 63.2 61.9 63.2 39.6 0 54.4-28.5 56.8-43.1H164v-34.4h94.4c1 5 1.6 10.1 1.6 16.6 0 57.1-38.3 97.6-96 97.6zm220-81.8h-29v29h-29.2v-29h-29V245h29v-29H355v29h29v29.2z"></path></svg></a>
								</div> 
							</div>
						</div>
					</template>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>

export default {
	props: {
    footerData: {
      type: Object
    }
  },

	methods: {
		addProtocol() {
			const elements = document.querySelectorAll('.social-icon a');

			for (const element of elements) {
				let href = element.getAttribute('href');

				if (!href.startsWith('https://')) {
					if (href.startsWith('http://')) {
						href = href.replace('http://', 'https://');
					} else {
						href = 'https://' + href;
					}

					element.setAttribute('href', href);
				}
			}
		}
	},

	mounted() {
		this.addProtocol();
	}
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/design-aachen/footerComponent.scss";
</style>